import styled from 'styled-components';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import COLORS from '../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';

export const SwiftContainer = styled.div`
  flex: 1;
  margin-left: 10px;
  ${(p) => p.isSingleRowField && 'margin: 0 0 16px 0'};
  z-index: ${(p) => (p.setZIndex ? '7' : '8')};
  @media only screen and (max-width: 1080px) {
    margin-top: 8px;
    width: ${(p) => (p.isSingleRowField ? '100%' : '334px')};
    margin-bottom: 0px;
    margin-left: 9px;
    ${(p) => p.isSingleRowField && 'margin: 0 0 16px 0'};
  }
`;

const gridCol3 = `
display: grid;
grid-template-columns: repeat(3, 1fr);
grid-row-gap: 40px;
grid-column-gap: 20px;
@media only screen and (max-width: 1080px) {
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
}
@media only screen and (max-width: 800px) {
  grid-row-gap: 0px;
}
`;
export const BankDetailsContainer = styled.div`
  ${({ isSingleRowField }) => !isSingleRowField && gridCol3};
  margin-top: 15px;

  ${({ isSingleRowField }) =>
    !isSingleRowField &&
    `
      @media only screen and (max-width: 1080px) {
        width: 340px;
        margin: 0 auto;
      }
    `}

  .mainClass {
    width: 100%;

    ${({ isSingleRowField }) => isSingleRowField && `margin-bottom: 25px;`}

    ${({ isSingleRowField }) =>
      !isSingleRowField &&
      `
        @media only screen and (max-width: 1080px) {
          width: 346px;
          margin-left: 3px;
          margin-top: 0px;
        }
      `}

    div {
      div {
        @media only screen and (min-width: 1080px) {
          margin: 0px;
        }
      }
    }
  }

  div > div {
    @media only screen and (min-width: 797px) {
      margin: 0px;
    }
  }
`;
export const Title = styled.div`
  display: flex;
  font-family: ${FONT_FAMILY.hellix.regular};
  width: 100%;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: ${COLORS.black};
  margin-bottom: 15px;
  margin-left: 10px;
  margin-top: 44px;
  @media only screen and (min-width: 500px) and (max-width: 1080px) {
    justify-content: center;
  }
`;

export const SwiftMessageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%;' : 'width: 327px')};
  font-size: 12px;
  margin-top: 3px !important;
  @media only screen and (min-width: 981px) and (max-width: 1108px) {
    ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%' : 'width: 285px')};
  }
`;
export const SwiftLink = styled.a`
  margin-left: 3px;
  text-decoration: underline;
`;
export const FieldContainer = styled.div`
  ${({ isSingleRowField }) => !isSingleRowField && `margin-right: 20px`};

  display: flex;
  flex-direction: row;
  flex: 1;

  .debitCardBox {
    div {
      div {
        @media only screen and (min-width: 797px) {
          margin: 0px;
        }
      }
    }
    @media only screen and (max-width: 600px) {
      width: 106%;
      margin-left: 18px;
    }
    @media only screen and (min-width: 600px) and (max-width: 1080px) {
      width: 334px;
      margin-left: 18px;
    }
    width: 334px;
  }

  .singleRowField {
    width: 100% !important;
    margin-left: 0px !important;
  }
  .visaImages {
    margin-left: -86px;
    margin-top: 13px;
    z-index: 999;
    @media only screen and (max-width: 1080px) {
      margin-top: -36px;
      margin-left: 256px;
    }
  }
  .cnyFieldCase {
    position: absolute;
    left: 39%;
    width: 100%;

    div {
      div {
        @media only screen and (min-width: 797px) {
          margin: 0px;
        }
      }
    }

    @media only screen and (max-width: 1700px) {
      left: 36%;
    }
    @media only screen and (min-width: 1700px) and (max-width: 2000px) {
      left: 36.5%;
    }
    @media only screen and (max-width: 1100px) {
      position: initial;
      width: 334px;
    }

    @media only screen and (min-width: 790px) and (max-width: 1080px) {
      width: 316px;
    }
  }

  .cnyBankCardNumberStyle {
    width: 334px;
    display: flex;
    @media only screen and (max-width: 1080px) {
      width: 334px;
    }

    div {
      width: 100%;

      div {
        @media only screen and (min-width: 1080px) {
          margin: 0px;
        }
      }

      @media only screen and (max-width: 1080px) {
        width: 98.7%;
      }
    }
  }
  .fullWidthField {
    width: 100% !important;
  }
  ${(props) => props.style}
  .render-text-field-edit {
    width: 100%;
  }
  @media only screen and (max-width: 1080px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  ${({ isSingleRowField }) => isSingleRowField && `width: 100%; !important`};
`;
export const CardMessageContainer = styled.div`
  font-size: 12px;
  color: #57b578;
  margin-top: 30px;
  ${({ $isSingleRowField }) =>
    !$isSingleRowField &&
    `
  padding-left: 13px;`};
  @media only screen and (max-width: 797px) {
    ${({ $isSingleRowField }) =>
      !$isSingleRowField &&
      `
   width: 344px;`};
  }
`;

export const SaveButton = styled.button`
  background-color: ${({ bgColor }) => (bgColor ? bgColor : '#009adf')};
  color: ${({ color }) => (color ? color : '#fff')};
  border-radius: 15px;
  padding: 10px;
  text-align: center;
  border: none;
  height: 35px;
  align-self: center;
  grid-column: 2/3;
  cursor: pointer;
  min-width: 140px;
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
export const LabelText = styled.div`
  color: ${COLORS.black};
  font-size: 14px;
  margin-top: 30px;
  margin-bottom: 20px;
  ${({ $isSingleRowField }) => !$isSingleRowField && 'margin-left: 10px'};
  ${(props) => props.style}
`;
export const TNCText = styled.div`
  ${({ isSingleRowField }) => isSingleRowField && 'width: 100%'};
  color: ${COLORS.textLightGrey};
  font-size: 14px;
  ${({ isSingleRowField, isNewBeneAddFlow }) =>
    isSingleRowField && !isNewBeneAddFlow ? 'margin-top: 20px' : 'margin-top: 45px'};
  margin-left: 10px;
  ${(props) => props.style}

  @media screen and (max-width: 1080px) {
    ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%; padding-top: 35px' : '325px')};
  }
`;
export const FAQText = styled.div`
  ${({ isSingleRowField }) => isSingleRowField && 'width: 100%'};
  color: ${COLORS.textLightGrey};
  margin-bottom: 20px;
  margin-left: 10px;
  ${(props) => props.style};
  font-size: 12px;
  padding-top: 5px;

  @media screen and (max-width: 1080px) {
    ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%' : '325px')};
  }
`;
export const VisaImage = styled.img`
  width: 25px;
  height: 12px;
  margin-top: 2px;
  ${(props) => props.style}
`;

export const EditText = styled.img`
  width: 25px;
  height: 12px;
  margin-top: 13px;
  height: 25px;
  margin-left: -44px;
  z-index: 999;
  cursor: pointer;
  ${(props) => props.style}
  @media screen and (max-width: 1080px) {
    margin-top: 21px;
  }
`;

export const FastFundImage = styled.img`
  margin-right: 5px;
  ${(props) => props.style}
`;

export const ButtonContainer = styled.div`
  grid-column: 1 / 3;
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : '0px')};
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
`;
export const StyledGrid = styled(Grid.Column)`
  grid-column: 1/3;
`;

export const LabelTextNormal = styled.div`
  font-family: 'hellix-regular';
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${COLORS.textLightGrey};
  margin-top: 10px;
  margin-bottom: 10px;
  padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '0px;')};

  @media only screen and (max-width: 797px) {
    width: 450px;
  }
`;
